<template>
    <div class="container">
    <div class="item">
        <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Capa 1"
      width="100"
      height="100"
      viewBox="0 0 192 192"
    >
      <path
        d="m88.17 34.36-69.93 69.92 15.65 15.65-15.65 15.65 69.93 69.92
    15.65-15.65 15.64 15.65 69.93-69.92-15.65-15.65
    15.65-15.65-69.93-69.92L103.82 50Zm-62.81 70.23 63.12-63.11 11.93 11.93-4.36
    4.36Q78.85 75 77.41 93.52 58.87 95 41.66 112.17l-4.36 4.35ZM112 174.87l-8.18
    8.13-8.18-8.17q-13.2-13.2-14.43-27.11 11.46-.56 22.61-8.1 11.15 7.56 22.6
    8.1-1.23 13.91-14.43 27.11m8.1-59.58a81.28 81.28 0 0 0-5.62-6.21 69.14 69.14
    0 0 0-6.06-5.4 37.15 37.15 0 0 1 17-5.34 37.11 37.11 0 0 1-5.31
    17m-9.34-2.5a75.31 75.31 0 0 1 6.28 7.08 65 65 0 0 1-6.07 7 74.81 74.81 0 0
    1-7.14 6.31 73.69 73.69 0 0 1-7.15-6.31 65 65 0 0 1-6.07-7 75.31 75.31 0 0 1
    6.28-7.08 63.2 63.2 0 0 1 6.94-6 64.07 64.07 0 0 1 6.93 6m9.45 11.57a38.32
    38.32 0 0 1 6.28 18.23 38.16 38.16 0 0 1-18.18-6.25 83.28 83.28 0 0 0
    6.37-5.76 71.15 71.15 0 0 0 5.53-6.22m-20.87 12a38.16 38.16 0 0 1-18.18 6.25
    38.23 38.23 0 0 1 6.29-18.23 69.39 69.39 0 0 0 5.55 6.19 85.21 85.21 0 0 0
    6.37 5.76m-6.17-27.26a81.28 81.28 0 0 0-5.62 6.21 37.23 37.23 0 0 1-5.31-17
    37.15 37.15 0 0 1 17 5.34 69.14 69.14 0 0 0-6.06 5.4m-9 10.69Q76.53 131 76
    142.54q-13.89-1.24-27.1-14.44l-8.18-8.17 4.67-4.67q15.4-15.42
    31.9-16.82a42.14 42.14 0 0 0 6.89 21.33m39.27 0a42.14 42.14 0 0 0
    6.89-21.33q16.5 1.41 31.92 16.82l4.67 4.67-8.18 8.17q-13.2 13.2-27.1
    14.44-.56-11.53-8.2-22.77m1.86-26.37a42.24 42.24 0 0 0-21.49 7 42.3 42.3 0 0
    0-21.5-7q1.43-16.5 16.83-31.92l4.67-4.66 4.66 4.66q15.42 15.43 16.83
    31.92m-36.83 105-63.12-63.13 11.94-11.94 8.28 8.28Q60.37 146.4 76 147.7q1.3
    15.68 16.09 30.47l8.28 8.28Zm93.79-63.11-63.12 63.11-11.93-11.93
    8.28-8.28q14.79-14.79 16.09-30.47 15.67-1.29
    30.47-16.09l8.27-8.28Zm-63.12-93.81 63.12 63.11-11.94
    11.93-4.33-4.35q-17.21-17.22-35.75-18.65-1.47-18.52-18.67-35.75l-4.36-4.36Z"
        :style="estilosElemento[0]"
        transform="translate(-18.24 -34.36)"
      />
      <path
        class="animate-logo"
        d="M90.6 119.87a62.59 62.59 0 0 1 13.21-13.12A66 66 0 0 1 117 119.87a69.71
    69.71 0 0 1-13.22 13.31 74.37 74.37 0 0 1-13.18-13.31"
        :style="estilosElemento[1]"
        transform="translate(-18.24 -34.36)"
      />
    </svg>
    </div>
  </div>
    

</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      estilosElemento: [
        {
          fill: "#d5ba8c",
        },
        { fill: "#812819" },
      ],
    };
  },
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
}
.container {
  display: flex;
  justify-content: center; 
  align-items: center; 
  height: 20vh; 
}
.animate-logo {
  animation: fadeIn 700ms infinite alternate;
}
</style>
